import React, { Component } from "react";

import CopyDeleteMenu from "./CopyDeleteMenu/CopyDeleteMenu";
import QuestionSelectorMenu from "./QuestionSelectorMenu/QuestionSelectorMenu";

import "./styles.css";

class QuestionCreatorHeaderMenu extends Component {
  finishQuestion() {
    this.props.updater();
    this.props.history.push("/question/list");
  }

  render() {
    return (
      <div className="question-creator-header">
        <div>
          <QuestionSelectorMenu
            readOnly={this.props.readOnly}
            currentTypeId={this.props.currentTypeId}
            items={this.props.itemTypes}
            typeSelector={this.props.typeChanger}
          />
        </div>
        {this.props.onActivity ? (
          <div>
            <CopyDeleteMenu
              questionId={this.props.questionId}
              questionDuplicator={this.props.questionDuplicator}
              questionDeleter={this.props.questionDeleter}
              questionEditor={this.props.questionEditor}
              onActivity={this.props.onActivity}
              questionValue={this.props.questionValue}
              valueShare={{
                totalValue: this.props.valueShare.totalValue,
                questionsAmount: this.props.valueShare.questionsAmount,
                shareValue: this.props.valueShare.shareValue
              }}
              questionValueChanger={this.props.questionValueChanger}
              disabled={this.props.disabled}
              released={this.props.released}
            />
          </div>
        ) : (
          <button
            className="finish-question-button"
            onClick={() => this.finishQuestion()}
          >
            <p>Finalizar</p>
            <i className="fa fa-chevron-right"></i>
          </button>
        )}
      </div>
    );
  }
}

export default QuestionCreatorHeaderMenu;
